type MappingValue = { [key: string]: { brand: string; logo: string } }

export default class BrandMapping {
  private static MAPPING: MappingValue = {
    AWB: { brand: 'sd', logo: 'awb' },
    BULEX: { brand: 'sd', logo: 'bulex' },
    'GLOW-WORM': { brand: 'sd', logo: 'glowworm' },
    HERMANN: { brand: 'sd', logo: 'hermann' },
    PROTHERM: { brand: 'sd', logo: 'protherm' },
    SAUNIERDUVAL: { brand: 'sd', logo: 'saunierduval' },
    SDBG: { brand: 'sd', logo: 'saunierduval' },
    VAILLANT: { brand: 'va', logo: 'vaillant' }
  }

  static getLogo(brand: string): string {
    return this.MAPPING[brand.toUpperCase()]?.logo
  }

  static getFavicon(brand: string): string {
    return this.getLogo(brand.toUpperCase())
  }

  static getBrandShortHand(brand: string): string {
    return (this.MAPPING[brand.toUpperCase()] || this.MAPPING.VAILLANT).brand
  }
}
